import { connect } from 'react-redux';
import { withListTieredBonus } from 'src/_shared/api/components/tiered-bonuses/';
import { compose } from 'src/_shared/services/utils.js';
import IntegrationsDashboard from './IntegrationsDashboard.jsx';

// Route container for /integrations: `connect` supplies currentUser (outermost, so
// withListTieredBonus can read currentUser.companyId) and injects `bonuses`, handed to the editor's
// embedded job-sync config as `tieredBonuses`.
function IntegrationsRoute({ currentUser, bonuses }) {
	return (
		<IntegrationsDashboard
			currentUser={currentUser}
			company={currentUser?.company}
			tieredBonuses={bonuses}
		/>
	);
}

const mapStateToProperties = (state) => ({
	currentUser: state.user.currentUser,
});

const WithApi = compose(withListTieredBonus)(IntegrationsRoute);

// Hydration gate: on a fresh origin the host-scoped jwt cookie can mark the app authenticated
// before redux-persist (port-scoped localStorage) rehydrates currentUser — and
// withListTieredBonus reads currentUser.companyId in its query options at mount. Hold rendering
// until the user exists so the route can't crash in that window.
function GatedIntegrationsRoute({ currentUser }) {
	if (!currentUser?.companyId) return null;
	return <WithApi currentUser={currentUser} />;
}

export const CompanyIntegrations = connect(mapStateToProperties)(GatedIntegrationsRoute);
